const state = {
  showContactDialog: false, // 展示联系我们弹窗
}

export default state
